// extracted by mini-css-extract-plugin
module.exports = {"slide":"__________Desktop_slide__dflGA"};